export enum INTERVENTIONS_STORAGE_KEYS {
  InterventionsCustomerOkFilterPreference = "appointment-details-interventions-customer-ok-filter-preference"
}
